import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/app/context/Auth/AuthContext";

import {
	getActiveManagedCompanyId,
	hasValidClaimSession,
	isAdminClaimSession,
} from "@/app/services/companies/claimSession.js";

import CompanyDashboardLayout from "./CompanyDashboardLayout";
import { CompanyDashboardProvider } from "./CompanyDashboardProvider";
import SetupPage from "./SetupPage";
import UpgradePage from "./UpgradePage";

function CompanyDashboardAccessGate({ children }) {
	const location = useLocation();
	const { authorizationToken, logout } = useAuth();
	const hasAccess = hasValidClaimSession(authorizationToken);

	useEffect(() => {
		if (!hasAccess) logout();
	}, [hasAccess, logout]);

	if (!hasAccess) {
		return <Navigate to="/companies" replace />;
	}

	if (isAdminClaimSession(authorizationToken) && !getActiveManagedCompanyId()) {
		return <Navigate to="/companies" replace state={{ from: location }} />;
	}

	return children;
}

export function CompanyDashboardRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<CompanyDashboardLayout />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}

export function CompanyDashboardSetupRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<SetupPage />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}

export function CompanyDashboardUpgradeRoute() {
	return (
		<CompanyDashboardAccessGate>
			<CompanyDashboardProvider>
				<UpgradePage />
			</CompanyDashboardProvider>
		</CompanyDashboardAccessGate>
	);
}
